import { CollisionCheckPosition } from "./collision_check_position.js";

export class CollisionCheck extends CollisionCheckPosition {

}